import { useGlobalContext } from '@honeycomb/data';
import { Paper, TypographyBody } from '@honeycomb/ui-core';
import React from 'react';
export function AutocompleterNoMatches() {
    const { resourceStrings: { AUTOCOMPLETER_NORESULTS }, } = useGlobalContext();
    return (React.createElement(Paper, { radius: "s", p: 3 },
        React.createElement(TypographyBody, { color: "system.error.base" }, AUTOCOMPLETER_NORESULTS)));
}
